<template>
    <path :style="{ fill: color }" d="M67.3,24.5c2.9,1.1,3.1,7.5,3.4,9.9c0.3,2.4,1,3.9,1.3,6.2c0.1,0.5,0.1,0.9,0.1,1.4
	c0,0-0.1,2.4-0.4,5.2s0.7,0.6,0.7,0.6l0.9-4c0.3-1.2,0.7-2.3,1.3-2.6c0,0,0.4-1,0.4-3c0-0.9-0.1-2.2,0-3.4c0.1-1.5,0.4-2.9,0.5-3.5
	c0.4-2.3,1.8-7.7-0.1-13.1c-1.9-5.4-5.4-5.4-6.6-6.4c-0.6-0.5-1.3-2.2-2.5-3.2c-1.4-1-3.3-1.2-4.6-1c-0.7,0.1-2.4-3.4-4.5-4.1
	s-1.9,2.5-1.9,2.5s-5.6-2.9-9.7-3.2c-4.1-0.3-3.7,4-3.7,4s-7.7-1-9.4,1.5C29.6,12.5,32,19.3,32,19.3s-1,2.7-0.9,6.4
	c0.1,3.8,0.8,5.2,1,7.9c0.3,3.3-0.6,5.7-0.1,7.8c0.1,0.1,0.3,0.4,0.4,0.8c0.2,0.6,0.6,1.7,1,3.5c0.7,3.5,1.5,3,1-0.7c0,0,0,0,0,0
	c-0.1-0.9-0.2-1.6-0.2-2.1c-0.1-2,1.4-4.9,1.5-8c0.1-3.1,0.3-6.3,2.4-9.3c2.1-3.1,6.4,2.6,15,2.6S64.4,23.4,67.3,24.5z"/>
</template>

<script>
    import Hair from './Hair';

    export default {
        name: 'Hair7',
        mixins: [Hair],
    }
</script>

